import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDistanceToNow } from "date-fns";
import moment from "moment";
const TicketDetailModal = ({ show, onHide, ticket }) => {
  if (!ticket) return null;
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      dialogClassName="ticket-detail-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Ticket Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Vehicle Number:</strong> {ticket.vehicle_number}
        </p>
        <p>
          <strong>Assigned To :</strong> {ticket.assigned_to?.name}
        </p>
        <p>
          <strong>Category:</strong> {ticket.category?.name || "N/A"}
        </p>
        <p>
          <strong>Ticket Issued:</strong>{" "}
          {formatDate(ticket.dates?.ticket_issued)}
        </p>
        <p>
          <strong>Ticket Resolved:</strong>{" "}
          {formatDate(ticket.dates?.ticket_resolved)}
        </p>
        <p>
          <strong>Heading:</strong> {ticket.heading}
        </p>
        <p>
          <strong>Status:</strong> {ticket.status}
        </p>
        <p>
          <strong>Description:</strong> {ticket.description}
        </p>
        <p>
          <strong>Pending Issue:</strong> {ticket.pendingissue}
        </p>

        <div className="mt-4">
          <strong>Comments:</strong>
          {Array.isArray(ticket.comments) && ticket.comments.length > 0 ? (
            <div className="mt-2 d-flex flex-column gap-2">
              {ticket.comments.flatMap((comment, index) => {
                let parsedComments;
                try {
                  parsedComments = JSON.parse(comment.text);
                  if (!Array.isArray(parsedComments)) throw new Error();
                } catch {
                  parsedComments = [{ text: comment.text, date: comment.date }];
                }

                return parsedComments.map((c, subIndex) => {
                  const dateObj = c.date ? new Date(c.date) : null;

                  return (
                    <div
                      key={`${comment._id}-${subIndex}`}
                      className="p-2 border rounded bg-light"
                      style={{ whiteSpace: "pre-wrap" }}
                    >
                      <textarea
                        className="form-control"
                        value={c.text || ""}
                        readOnly
                        rows={Math.min(
                          Math.max((c.text || "").split("\n").length + 2, 4),
                          12,
                        )}
                        style={{
                          resize: "vertical",
                          backgroundColor: "#fff",
                          fontFamily: "monospace",
                          whiteSpace: "pre-wrap",
                          overflowY: "auto",
                        }}
                      />
                      {dateObj && (
                        <div
                          className="text-muted"
                          style={{ fontSize: "0.8em" }}
                        >
                          {dateObj.toLocaleString(undefined, {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                          })}
                          {"                 "}
                          {/* Updated{" "}
                          {formatDistanceToNow(dateObj, { addSuffix: true })} */}
                          <span style={{ color: "red" }}>
                            Updated{" "}
                            {formatDistanceToNow(dateObj, { addSuffix: true })}
                          </span>
                        </div>
                      )}
                    </div>
                  );
                });
              })}
            </div>
          ) : (
            <p className="text-muted">No comments available</p>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default TicketDetailModal;
